<template>
    <modal id="tenant-notification-translate-modal"
           size="large"
           v-model="showModal"
           :title="$t('translate')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            @submit.prevent="submitData"
        >
            <app-form-group
                :label="$t('to_language')"
                type="select"
                :chooseLabel="$t('type')"
                v-model="formData.to"
                :list="languages"
                :required="true"
            />
        </form>
    </modal>
</template>

<script>
import { set } from "lodash";
import { TENANT_BASE_URL } from "../../../../../common/Config/UrlHelper";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {mapState} from "vuex";

export default {
    name: "TenantNotificationTranslate",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            formData: {
                to: 'ja',
            },
        }
    },
    computed: {
        ...mapState({
            languages: state => state.support.languages
        }),
    },
    methods: {
        submitData() {
            this.loading = true;
            const formData = this.formData;
            const url = `${TENANT_BASE_URL}notification/events/translate`;
            this.submitFromFixin('post', url, formData);

            setTimeout(() => {
                this.loading = false;
                $('#tenant-notification-translate-modal').modal('hide');
                this.$emit('input', false);
                this.toastAndReload(this.$t('notification_templates_translated_successfully'), 'notification-event');
            }, 2000);
        },
        // afterSuccess({data}) {
        //     this.loading = false;
        //     $('#tenant-notification-translate-modal').modal('hide');
        //     this.$emit('input', false);
        //     this.toastAndReload(data.message, 'notification-event');
        // },
    },
}
</script>
